import { Box } from "@mui/material";

export const LoadingIndicator = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      mb: 2,
      gap: 0.8,
    }}
  >
    {[0, 1, 2].map((i) => (
      <Box
        key={i}
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: "grey.600",
          animation: "smoothBounce 1.4s ease-in-out infinite",
          animationDelay: `${i * 0.25}s`,
          "@keyframes smoothBounce": {
            "0%, 80%, 100%": { transform: "scale(0.4)", opacity: 0.4 },
            "40%": { transform: "scale(1)", opacity: 1 },
          },
        }}
      />
    ))}
  </Box>
);
